import { Component, ViewChild } from '@angular/core'
import { IonicPage, NavController, NavParams, ToastController, Events } from 'ionic-angular'
import { CallComponent } from '../../components/call/call'
import { HousingUnit, SignalingMessage, Device, DomainEvents } from '../../models/models'
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit'
import { DeviceProvider } from '../../providers/device/device'

/**
Parametri costruttore:

- call_init: Se valorizzato è il chiamato e contiene il messaggio coi dettagli del chiamante, altrimenti è il chiamante
- isVideoSent: Abilita l'invio video, default true
- otherId: Peer id dell'altro interlocutore; se non impostato usa il mittente di call_init
- housingUnit: Unità abitativa chiamata, se non impostato prova a recuperarlo da call_init
*/
@IonicPage()
@Component({
	selector: 'page-call',
	templateUrl: 'call.html',
})
/**
 * Visualizzata DOPO aver eseguito il PING
*/
export class CallPage {

	public device: Device
	public housingUnit: HousingUnit

	/**
	True se è ha già chiuso la chiamata, deve chiudere la pagina
	*/
	private isClosed: boolean = false;

	public isCaller: boolean = null;
	/**
	Abilita l'invio di video
	*/
	public isVideoSent: boolean = null;

	private isActivePage = false;

	private _leavingMessage: string = null;
	private get leavingMessage(): string {
		if(this._leavingMessage) {
			return this._leavingMessage
		}
		return 'Chiusura chiamata'
	}
	private set leavingMessage(message: string) {
		this._leavingMessage = message
	}

	/**
	Gestore evento chiusura chiamata
	*/
	private onCloseHandler: any

	public otherId: string = null;

	@ViewChild('call') call: CallComponent

	constructor(
		private devices: DeviceProvider,
		private events: Events,
		//private flavour: FlavourProvider,
		private housingUnits: HousingUnitProvider,
		private navCtrl: NavController,
		private navParams: NavParams,
		//private viewCtrl: ViewController,
		private toastCtrl: ToastController,
		//private webrtc: WebrtcProvider
	) {
		this.otherId = this.navParams.get('otherId')
		this.housingUnit = this.navParams.get('housingUnit')

		let callInit: SignalingMessage = this.navParams.get('callInit')

		//Gestore chiusura chiamata
		this.onCloseHandler = (message: string) => {
			console.debug('[CallPage.onCloseHandler(message)] Chiamata chiusa dal componente: ' + message)
			this.leavingMessage = message
			this.isClosed = true

			if(this.isActivePage) {
				this.navCtrl.pop()
				//this.navCtrl.setRoot(this.flavour.actualRoot)
			}
		}

		this.events.subscribe(DomainEvents.VOIPCALL_CLOSE, this.onCloseHandler)


		if(callInit) {//call init: Chiamata in arrivo
			this.isCaller = false
			let self = this
			//peer ID chiamante
			if(!this.otherId) {
				this.otherId = callInit.senderId
			}

			//unità abitativa chiamata
			if(!this.housingUnit) {//U.I. non esplicita, prova a cercarla da call_init
				let housingUnitId = callInit.housingUnitId
				if(housingUnitId) {
					this.housingUnits.getById(housingUnitId, ['condominium']).then(housingUnit => {
						self.housingUnit = housingUnit
					})
				}
			}

			//dispositivo chiamante
			let deviceId = callInit.deviceId
			if(deviceId) {
				this.devices.getById(deviceId).then(device => {
					self.device = device
				})
			}
		} else {
			this.isCaller = true
		}


		this.isVideoSent = this.navParams.get('isVideoSent')
		if(this.isVideoSent === null) {
			this.isVideoSent = true
		}
		console.log('Apertura pagina chiamata con parametri: otherId=' + this.otherId + ', isCaller=' + this.isCaller + ', isVideoSent=' + this.isVideoSent)
	}

	ionViewWillEnter() {

	}

	ionViewDidEnter() {
		this.call.ionViewDidEnter()
		this.isActivePage = true
		if(this.isClosed) {//ha chiuso la chiamata più velocemente di quanto abbia chiuso la pagina, la chiude
			this.navCtrl.pop()
		}
	}

	ionViewDidLoad() {
	}

	ionViewDidLeave() {
		console.debug('[CallPage.ionViewDidLeave()] Pagina chiamata rimossa dallo stack')
		this.events.unsubscribe(DomainEvents.VOIPCALL_CLOSE, this.onCloseHandler)
		this.isActivePage = false
		this.call.ionViewDidLeave()
	}

	ionViewWillLeave() {
	}

	ionViewWillUnload() {
		console.debug('Finalizzazione della pagina di chiamata')
		this.isClosed = true

		//this.webrtc.disconnect()

		let message = this.leavingMessage

		let duration = 3000
		let toast = this.toastCtrl.create({
			message: message,
			position: 'middle',
			duration: duration
		})
		toast.present()

		//eventuale chiamata non chiusa si chiude adesso, liberando le risorse
		this.call.hangUp()
	}
}



// WEBPACK FOOTER //
// ./src/pages/call/call.ts